import React from "react";
import styles from "./Real.module.css";
import improveImg from "../../assets/portrait.jpg";

const Real = () => {
  return (
    <div className="mb-5 overflow-hidden container">
      <div className="Menucard overflow-hidden ">
        {" "}
        <div className="row ">
          <div className={`col-md-4 ${styles.imgDiv}`}>
            <img
              data-aos="slide-right"
              data-aos-offset="150"
              src={improveImg}
              alt=""
              className={styles.img}
            />
          </div>
          <div className="col-md-7 container">
            <div className={styles.text}>
              <p
                data-aos="slide-right"
                data-aos-offset="150"
                className={styles.heading}
              >
                Our Games
              </p>
              <p
                data-aos="slide-left"
                data-aos-offset="150"
                className={styles.subHeading}
              >
                Experience One Of The Best Sports In The World{" "}
              </p>
              <p
                data-aos="zoom-in"
                data-aos-offset="150"
                className={styles.content}
              >
                Responsive web design supply chain crowdfunding agile
                development analytics technology ownership startup. Network
                effects social proof user experience prototype buzz product
                management deployment metrics sales infographic equity holy
                grail crowdfunding release.{" "}
              </p>
              <div className="row container">
                <div className="col-md-3 smallcard m-2 " data-aos="fade-up">
                  <h6>
                    {" "}
                    Snooker <br></br>per minute
                  </h6>
                  <p>
                    Rs.<span>4.0</span>
                  </p>
                </div>{" "}
                <div className="col-md-3 smallcard m-2 " data-aos="fade-up">
                  <h6>
                    {" "}
                    8 ball Pool <br></br>
                    per game
                  </h6>
                  <p>
                    Rs.<span>80.0</span>
                  </p>
                </div>{" "}
                <div className="col-md-3 smallcard m-2 " data-aos="fade-up">
                  <h6>
                    {" "}
                    Indoor games <br></br>per game
                  </h6>
                  <p>
                    Rs.<span>4.0</span>
                  </p>
                </div>{" "}
              </div>
              {/* <div data-aos="zoom-in" style={{ textAlign: "left" }}>
                <button className={`btn custom_btn ${styles.btn}`}>
                  LET&apos;S TALK
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Real;
